import TransferAccountSelector from './transfer-account-selector';

export default TransferAccountSelector;
